import { Injectable } from '@angular/core';

const STORAGE_KEY = 'premiervet_attribution';

@Injectable({
  providedIn: 'root'
})
export class AttributionService {
  captureFromUrl(): void {
    if (typeof window === 'undefined') return;
    try {
      const params = new URLSearchParams(window.location.search);
      const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'campaign_id', 'crm_source', 'channel'];
      const data: Record<string, string> = {};
      keys.forEach(k => {
        const v = params.get(k);
        if (v) data[k] = v;
      });
      if (Object.keys(data).length) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        console.log('AttributionService: captured', data);
      }
    } catch (e) {
      console.error('AttributionService capture error', e);
    }
  }

  getAttribution(): Record<string, string> | null {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  clearAttribution(): void {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
